import * as React from 'react';

import { setAgenciesTab, setRealtorsTab } from '../../actions/tabs';
import { useSelector } from 'react-redux';

import { ETabs } from '../../types/redux/tabs';
import { Tabs } from '../../components/Tabs';
import { getCurrentTab } from '../../selectors/tabs';
import { tabs } from '../../constants/filters';
import { useAppDispatch } from '../../hooks/useAppDispatch/useAppDispatch';

export function DesktopContainer() {
  const dispatch = useAppDispatch();
  const activeTab = useSelector(getCurrentTab);

  const changeTab = React.useCallback(
    (tab: ETabs) => {
      return dispatch((tab === ETabs.Realtors ? setRealtorsTab : setAgenciesTab)());
    },
    [dispatch],
  );

  return <Tabs tabs={tabs} onChange={changeTab} activeTab={activeTab} />;
}
